import { render } from "./Statements.vue?vue&type=template&id=77b804c0"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"

import "./Statements.vue?vue&type=style&index=0&id=77b804c0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__